import { render, staticRenderFns } from "./ReEngageApproval.vue?vue&type=template&id=0853c519&scoped=true"
import script from "./ReEngageApproval.vue?vue&type=script&lang=js"
export * from "./ReEngageApproval.vue?vue&type=script&lang=js"
import style0 from "./ReEngageApproval.vue?vue&type=style&index=0&id=0853c519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0853c519",
  null
  
)

export default component.exports